var init = require("init");

init.then(function (init) {
    require("../sass/normalize.scss");
    require("@material/layout-grid/mdc-layout-grid.scss");
    require("@os/typography/typography.scss");
    require("@os/mdc/button.scss");
    require("@os/mdc/layout-grid.scss");
    require("@os/helper/helper.scss");

    require("../sass/survey-optout/survey-optout.scss");

    var templateBody = require("../view/survey-opt-out.hbs");

    define([
        "jquery",
        "@os/header",
        "@os/footer",
        "@os/query-string",
    ], function ($, header, footer, queryString) {
        var survey = queryString.parseArguments("survey/optout/");
        var survey_id = survey[0];
        var survey_key = survey[1];
        $(function () {
            $.ajax({
                type: "POST",
                url: "/api/survey/optout",
                data: { survey_id: survey_id, survey_key: survey_key },
                dataType: "json",
            }).done(function (data) {
                $("#page-content").append(templateBody(data));
            });
        });
    });
});
